module.exports = __webpack_public_path__ + "img/pattern-secondary-dark.1519445.png";